<template>
  <div>
    <a-modal
      v-model="visible"
      :title="action + ' Branches'"
      :dialogStyle="{ top: '10px' }"
      :destroyOnClose="true"
    >
      <template slot="footer">
        <a-button class="btn btn-outline-dark" @click="handleCancel">
          Cancel
        </a-button>
        <a-button
          class="btn btn-outline-primary"
          :loading="loading"
          @click="submit('ruleForm')"
        >
          Submit
        </a-button>
      </template>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            :label-col="labelCol"
            :wrapper-col="wrapperCol"
          >
            <!-- <a-form-model-item
              style="margin: unset;"
              ref="bpr_id"
              label="BPR"
              prop="bpr_id"
            >
              <a-select v-model="form.bpr_id" show-search option-filter-prop="children" :filter-option="filterOption">
                <a-select-option
                  v-for="data in databpr"
                  :key="data.sandibpr"
                  :value="data.sandibpr"
                  >{{ data.sandibpr + ' - ' + data.namabpr }}</a-select-option
                >
              </a-select>
            </a-form-model-item> -->
            <a-form-model-item
              style="margin: unset;"
              ref="kode"
              label="Kode"
              prop="kode"
            >
              <a-input
                v-model="form.kode"
                @blur="
                  () => {
                    $refs.kode.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item
              style="margin: unset;"
              ref="sandi_kantor"
              label="Sandi Kantor"
              prop="sandi_kantor"
            >
              <a-input
                v-model="form.sandi_kantor"
                @blur="
                  () => {
                    $refs.sandi_kantor.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item
              style="margin: unset;"
              ref="alamat"
              label="Alamat"
              prop="alamat"
            >
              <a-input
                v-model="form.alamat"
                @blur="
                  () => {
                    $refs.alamat.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item
              style="margin: unset;"
              ref="keterangan"
              label="Keterangan"
              prop="keterangan"
            >
              <a-input
                v-model="form.keterangan"
                @blur="
                  () => {
                    $refs.keterangan.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
            <a-form-model-item
              style="margin: unset;"
              ref="induk"
              label="Induk"
              prop="induk"
            >
              <a-input
                v-model="form.induk"
                @blur="
                  () => {
                    $refs.induk.onFieldBlur();
                  }
                "
              />
            </a-form-model-item>
          </a-form-model>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import * as lou from '@/services/data/lou'
import moment from 'moment'

export default {
  name: 'editprofile',
  created() {
    // this.getMaster()
  },
  data() {
    // const validatePass = (rule, value, callback) => {
    //   // if (this.action === 'Create') {
    //   //   if (this.form.password_confirmation !== '') {
    //   //     this.$refs.ruleForm.validateField('checkPass')
    //   //   }
    //   //   callback()
    //   // } else {
    //   if (value === '') {
    //     callback(new Error('Please input the password'))
    //   } else {
    //     if (this.form.password_confirmation !== '') {
    //       this.$refs.ruleForm.validateField('checkPass')
    //     }
    //     callback()
    //   }
    //   // }
    // }
    // const validatePass2 = (rule, value, callback) => {
    //   // if (this.action === 'Create') {
    //   //   if (value !== this.form.password) {
    //   //     callback(new Error("Password doesn't match!"))
    //   //   } else {
    //   //     callback()
    //   //   }
    //   // } else {
    //   if (value === '') {
    //     callback(new Error('Please input the password again'))
    //   } else {
    //     if (value !== this.form.password) {
    //       callback(new Error("Password doesn't match!"))
    //     } else {
    //       callback()
    //     }
    //   }
    //   // }
    // }
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      user: [],
      datarole: [],
      databpr: [],
      roletags: false,
      editdata: {},
      action: 'Create',
      form: {
        kode: '',
        sandi_kantor: '',
        alamat: '',
        keterangan: '',
        induk: '',
      },
      rules: {
        kode: [{ required: true, message: 'Please input Kode!' }],
        sandi_kantor: [{ required: true, message: 'Please input Sandi Kantor!' }],
        alamat: [{ required: true, message: 'Please input Alamat!' }],
        // keterangan: [{ required: true, message: 'Please input Keterangan!' }],
        induk: [{ required: true, message: 'Please input Induk!' }],
      },
      loading: false,
      visible: false,
      datenow: null,
    }
  },
  methods: {
    moment,
    // async getMaster() {
    //   var resp = await lou.readMaster('id_role')
    //   this.datarole = resp.data
    // },
    selectDate(selectedDates, dateString, input) {
      // console.log('selectedDates', selectedDates)
      // console.log('dateString', dateString)
      // console.log('input', input)
      if (selectedDates !== null) {
        this.form[input] = dateString
      } else {
        this.form[input] = null
      }
    },
    userAppSelect(e) {
      // console.log('e', e)
      var temp = []
      for (let m = 0; m < e.length; m++) {
        const element = e[m]
        temp.push({ id_app: element })
      }
      // console.log('temp', temp)
      this.form.appLists = temp
    },
    async showModal(action, data = {}, kodebpr) {
      this.bprkode = kodebpr
      // console.log('data', data)
      this.editdata = data
      // var resbpr = await lou.customUrlGet('auth/sandibpr', false, true)
      // this.databpr = resbpr.data
      if (action === 'Update') {
        this.form.id = data.id
        this.form.kode = data.kode
        this.form.sandi_kantor = data.sandi_kantor
        this.form.alamat = data.alamat
        this.form.keterangan = data.keterangan
        this.form.induk = data.induk
        // console.log('this.form.selectedAppLists', this.form.selectedAppLists)
      } else {
        this.form.kode = ''
        this.form.sandi_kantor = ''
        this.form.alamat = ''
        this.form.keterangan = ''
        this.form.induk = ''
      }
      this.action = action
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    submit(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // console.log('this.form.appLists', this.form.appLists)
          var fd = {
            kode: this.form.kode,
            sandi_kantor: this.form.sandi_kantor,
            alamat: this.form.alamat,
            keterangan: this.form.keterangan,
            induk: this.form.induk,
          }
          if (this.action === 'Create') {
            await lou.createMaster('manage/branches?bpr_id=' + this.bprkode, fd, true, true)
          } else {
            fd.id = this.form.id
            await lou.updateMaster('manage/branches?bpr_id=' + this.bprkode, fd, true, true)
          }
          this.$parent.getData()
          this.visible = false
          this.resetForm(formName)
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
  },
}
</script>

<style></style>
